import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import { StepId } from 'webapp/services/wizard';

export default class WizardSourceRoute extends Route {
	@service('wizard') declare wizardService: Service.Wizard;

	override beforeModel() {
		this.wizardService.activeStep = StepId.SOURCE;
		this.wizardService.createdCustomQuery = null;
	}
}
